module.exports = __webpack_public_path__ + "static/img/boss_scenario.46e3d157.png";